import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Diensten {
    constructor() {
        if (document.querySelector('#show.page-diensten') !== null) {
            this.initUsps();
        }
    }

    initUsps() {
        new Swiper('#usps .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 6,
                }
            }
        });
    }
}
